import { CostSummary } from "@redotech/redo-model/trackable";
import { memo } from "react";

const rowStyle: React.CSSProperties = { paddingBottom: "8px" };
const priceStyle: React.CSSProperties = {
  float: "right",
  whiteSpace: "nowrap",
  minWidth: "60px", // not ideal, but Gmail gets rid of nowrap on mobile
};

export const CostSummarySection = memo(function CostSummarySection({
  priceBeforeDiscounts,
  discountStrings,
  shippingProduct,
  shippingProductCost,
  taxCost,
  totalCost,
}: CostSummary) {
  return (
    <div style={{ marginTop: "16px", fontSize: "16px", lineHeight: "1.5" }}>
      <table style={{ width: "100%" }}>
        <tr>
          <td style={rowStyle}>Subtotal</td>
          <td style={priceStyle}>{`${priceBeforeDiscounts}`}</td>
        </tr>
        {discountStrings?.map((discountString, index) => (
          <tr key={index}>
            <td style={rowStyle}>Discount</td>
            <td style={priceStyle}>{discountString}</td>
          </tr>
        ))}
        <tr>
          <td style={rowStyle}>{shippingProduct || `Shipping product`}</td>
          <td style={priceStyle}>{`${shippingProductCost}`}</td>
        </tr>
        <tr>
          <td style={rowStyle}>Tax</td>
          <td style={priceStyle}>{`${taxCost}`}</td>
        </tr>
        <tr>
          <td style={rowStyle}>
            <strong>Total</strong>
          </td>
          <td style={priceStyle}>
            <strong>{`${totalCost}`}</strong>
          </td>
        </tr>
      </table>
    </div>
  );
});
